import React, { Component } from 'react';
import '../myutils';
import {
  translate,
} from 'react-admin';
import BookIcon from '@material-ui/icons/Book';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import PhoneForwarded from '@material-ui/icons/PhoneForwarded';
import { configAPI } from '../config';
import {Dialog, DialogTitle, DialogActions, DialogContent, Tooltip, Paper, IconButton} from '@material-ui/core'
import Typography from '@material-ui/core/Typography';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import MyLocation from '@material-ui/icons/MyLocation';
import icons from '../res/icons'

export const TemplateIcon = BookIcon;

class TransferButton extends Component {

  state = {
    open: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      record: false,
      showDialog: false,
      nodeClicked: false,
      showOK:false
    }
  }

  Transition(props) {
    return <Fade timeout={{enter:0, exit:2600}} {...props} />;
  }
  
  transferCall(id) {
    var transferIds = sessionStorage.selectedIds;
    var transferPath = sessionStorage.nodeClicked.replace('ivr2:/','/').replace('ivr2:','/');
    var data = new FormData();
    data.append("token", sessionStorage.B.encodeDecode());
    data.append("action", "set:GOasap="+transferPath);
    data.append("ids", transferIds);

    return fetch(configAPI.api.prod + 'CallAction', {
      method: "POST",
      body: data
  });
  }

  render() {
    const { translate } = this.props;
    return (
      <div style={{ float: "right" }}>
        <IconButton onClick={(e) => {
          this.setState({ showDialog: true });
          if (this.props.call!=undefined) sessionStorage.setItem('selectedIds',this.props.call.id);
        }}>
          <PhoneForwarded></PhoneForwarded>
        </IconButton>
        
        <Dialog
          fullWidth={true}
          maxWidth = {'md'}
          TransitionComponent={this.Transition}
          transitionDuration = {{ enter: 0, exit: 2000}}
          open={this.state.showDialog}
        >
          <DialogTitle id="transferCall-dialog-title" style={{textAlign:"right"}}><h1>{translate(`trans.transferCallTitle`)}</h1></DialogTitle>
          <Typography style={{textAlign:"right"}} variant="headline">{translate(`trans.transferCallInstructions`)}</Typography>
          <Typography style={{textAlign:"right"}} variant="headline" color="error">{translate(`trans.transferCallNote`)}</Typography>
          <Paper style={{ height: `90%`, width: `100%`, overflow:'scroll' }} onClick={()=>this.setState({nodeClicked:!this.state.nodeClicked})}>
            <NavTree path={'/'} 
            translate={translate} nodeClicked={this.state.nodeClicked} 
            />
          </Paper>
          <DialogActions>
          <Button onClick={(e) => this.setState({ showDialog: false })} color="primary">
              {translate(`trans.cancel`)}
            </Button>
            <Button onClick={(e) => {sessionStorage.setItem('nodeClicked',"hangup"); this.transferCall();this.setState({showDialog:false})}} color="primary">
              {translate(`trans.transferCallHangup`)}
            </Button>
            <Button onClick={(e) => {this.transferCall();this.setState({showDialog:false})}} color="primary">
              {translate(`trans.transferCallAction`)}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

class NavTree extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
          children:[],
          clicked:false,
          visibleChildren: false,
          mylocation: false
      }
  }

  componentDidMount () {
      this.setState({children:[]});
      if (this.props.path==='/') this.loadX('/');
      this.setState({path:this.props.path});
  }      

  componentWillReceiveProps(newProps) {
    if( newProps.nodeClicked !== this.props.nodeClicked ) this.setState({mylocation:false});
  }

  loadX = (path) => {
      if (this.state.clicked===false){
                  this.setState({clicked:true, visibleChildren:true});                      
      }
      else {
          this.setState(prevState => ({
              visibleChildren: !prevState.visibleChildren
          }));
      }

      const request = new Request(configAPI.api.prod + '/GetIVR2Dir?&path='+path+'&token=' + sessionStorage.B.encodeDecode(), {
          headers: new Headers({
              'Content-Type': 'text/json'
          }),
          method: 'GET'
      });
      return fetch(request)
          .then(response => { return response.json(); })
          .then(IVRDIR => {
              this.setState({children:IVRDIR.dirs});                      
          })

  }

  treeClick(path){
      sessionStorage.setItem('nodeClicked',path);
      if (sessionStorage.nodeClicked === path) this.setState({mylocation:true});
      if (path!=='/') this.loadX(path);
  }

  render() {
      var path = this.props.path;
      var title = path.substring(path.lastIndexOf("/") + 1);
      var extTitle = this.props.extTitle;
      var icon;
      var extType = (this.props.extType!==undefined)?this.props.extType:'DIR';
      if (extType == undefined) icon = icons['DIR'];
      else icon = icons[extType];
      return (
          <DialogContent style={{paddingRight:10}}>
              <Tooltip title={this.props.translate(`type.`+extType)}>
                  <Button  style={{textTransform: 'none'}} onDoubleClick={()=>this.treeClick(path)}>
                  {(this.state.visibleChildren)?(<ChevronLeft/>):(<ArrowDropDown/>)}
                      {icon}
                      <Typography variant="caption">{title}</Typography>
                      {(extTitle!==undefined&&extTitle!=='')&&(<Typography variant="subheading">{'-"'+extTitle+'"'}</Typography>)}
                      {(this.state.mylocation)&&(<MyLocation/>)}
                  </Button>
              </Tooltip>
              {(this.state.visibleChildren)&&(
                  <div>
                      {this.state.children.map(child => {
                          return(<NavTree translate={this.props.translate} path={child.what} extTitle={child.extTitle} extType={child.extType} history={this.props.history} nodeClicked={this.props.nodeClicked}/>)  
                      })}
                  </div>
              )}
          </DialogContent>
          )
  }
}


export default translate(TransferButton);
